import objConfig from '@/view/homePage/mainjson.js'
import mainServiceData from '@/view/homePage/content/mainService/json.js'
import aboutUsData from '@/view/homePage/content/aboutUs/aboutUsData.js'

const { baseInfo, companyDetail, mainService, serviceAdvantage, partners, menuList } = objConfig

const state = {
  currentLanguage:localStorage.getItem('vipLang') || 'zh',

  baseInfo: baseInfo,
  companyDetail: companyDetail,
  mainService: mainService,
  serviceAdvantage: serviceAdvantage,
  partners: partners,
  menuList: menuList,

  mainServiceInfo: mainServiceData,
  aboutUsData:aboutUsData,
}
const mutations = {
  SET_LANGUAGE(state,language) {
    state.currentLanguage = language;
  }
}
const actions = {
  setLanguage({ commit },language){
    commit('SET_LANGUAGE',language);
    localStorage.setItem('vipLang',language)
  }
}
const getters = {
  currentLanguage: state => state.currentLanguage,
  baseInfo: state => state.baseInfo,
  companyDetail: state => state.companyDetail,
  mainService: state => state.mainService,
  serviceAdvantage: state => state.serviceAdvantage,
  partners: state => state.partners,
  menuList: state => state.menuList,

  mainServiceInfo: state => state.mainServiceData,
  aboutUsData: state => state.aboutUsData,
}

export default ({
    namespaced:true,
    state,
    mutations,
    actions,
    getters,
})



// WEBPACK FOOTER //
// ./src/store/languageStore.js